import React, { MouseEvent } from 'react'
import styled from 'styled-components/macro'

export type Props = {
  items: { text: string; onClick?: (index: MouseEvent) => void }[]
  selected: string
  style?: React.CSSProperties
  id?: string
}

export default function Tab({ items, selected, ...props }: Props) {
  return (
    <TabComponent {...props}>
      {items.map((item, index) => (
        <TabButton key={index} active={item.text === selected} onClick={item.onClick}>
          {item.text}
        </TabButton>
      ))}
    </TabComponent>
  )
}

const TabComponent = styled.div`
  height: 48px;
  border-bottom: 1px solid #d7d7d8;
  margin: 32px 0 0 0;
  width: 100%;
  overflow: hidden;
  &:after {
    content: '';
    display: block;
    clear: both;
  }
`

const TabButton = styled.button<{ active: boolean }>`
  border-style: solid;
  border-width: 0 0 4px 0;
  border-color: ${(props) => (props.active ? '#05A6C1' : '#9E9E9E')};
  background-color: #fff;
  font-weight: 500;
  padding: 10px 20px;
  color: ${(props) => (props.active ? '#05A6C1' : '#9E9E9E')};
  font-size: 16px;
  font-family: 'Montserrat';
  margin-top: 4px;
  margin-right: 4px;
  &:hover {
    transition: all 0.5s;
    color: #05a6c1;
    border-bottom: 4px solid #05a6c1;
  }
  &:first-letter {
    text-transform: uppercase;
  }
`
